import { MetadataStorage } from './MetadataStorage';
/**
 * Default metadata storage is used as singleton and can be used to storage all metadatas.
 */
export var defaultMetadataStorage = new MetadataStorage();
//# sourceMappingURL=storage.js.map